import * as $ from 'jquery';
import 'jquery-colorbox';
import DialogUtils from '../../lib/DialogUtils';
// import { Analytics } from '@plaudit/analytics';

export default class Product {
	protected selector: String = '#buy-direct';
	protected labelledby: string = 'addToCartForm-heading';
	protected element: JQuery = $('#buy-direct');
	protected ariaModalAttempt: number = 0;

	constructor() {
		this.formOnChangeHandler();
		this.updatePrice();
		this.formInLightbox();
	}
	public resetQuantity() {
		let firstOptionValue = (this.element).find('[name="quantity"] option:first-child').attr('value');
		(this.element).find('[name="quantity"]').val(firstOptionValue);
	}
	public updatePrice() {
		if (this.element.length !== 0) {
			const price = (this.element).find('[name="sizes"]:checked').data('price');
			const quantity = (this.element).find('[name="quantity"]').val();
			if (quantity) {
				const actualQuantity = parseInt(quantity.toString().substr(0, quantity.toString().indexOf('|')));

				(this.element).find('#addToCartFormPrice').text('$' + (actualQuantity * price).toFixed(2));
			}
		}
	}
	public formOnChangeHandler() {
		(this.element).find('[name]').on('change', (event) => {
			if (event.target.getAttribute('name') == 'sizes') {
				this.resetQuantity();
			}
			this.updatePrice();
		});
	}
	public formInLightbox() {
		$(`a[href*="${this.selector}"]`).colorbox({
			transition: 'elastic',
			opacity: .60,
			initialWidth: '200',
			initialHeight: '200',
			maxWidth: '90%',
			maxHeight: '90%',
			fixed: true,
			close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" height="44" fill="#FFFFFF" aria-hidden="true"><path d="M13.458 15.336l1.485-1.485 15.344 15.344-1.485 1.485z"> </path><path d="M12.961 29.2l15.344-15.343 1.485 1.485-15.344 15.344z"> </path></svg><span>Close</span>',
			href: this.element,
			inline: true,
			onOpen: () => {
				document.querySelector('html').classList.add('lockScroll');
			},
			onClosed: () => {
				document.querySelector('html').classList.remove('lockScroll');
				document.getElementById('colorbox').removeAttribute('aria-labelledby');
			},
			onComplete: () => {
				document.getElementById('cboxClose').classList.add('last-focusable-element');
				document.getElementById('colorbox').setAttribute('aria-labelledby', this.labelledby);
				DialogUtils.focusLock(document.getElementById('colorbox'));

				(this.element).find('.btn input[type="submit"]').on('click', function () {
					$.colorbox.close();
				});
			}
		});
	}
};
